'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { Editor, EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js'
import { Map } from "immutable";
/**
 * This avoids the scrolling problem, but getting plaintext out is currently
 * problematic so we need to think through the implementation in more detail.
 */
export class ResizableTextareaDraftJS extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {editor_state: this.getNewEditorStateFromInitialValue()};
    this.focus = () => this.editor_element.focus();
    this.setEditorRef = (ref) => this.editor_element = ref;
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.session_id != this.props.session_id) {
      this.setState({editor_state: this.getNewEditorStateFromInitialValue()});
    }
  }

  getNewEditorStateFromInitialValue = () => {
    let editor_state = EditorState.createWithContent(
      ContentState.createFromText(this.props.initial_value)
    );
    return editor_state;
  }

  handleChange = (new_editor_state) => {
    this.setState({editor_state: new_editor_state});
    this.props.onChange(new_editor_state.getCurrentContent().getPlainText());
  }

  render() {

    let placeholder_text = null;
    if (!this.props.readOnly) {
      placeholder_text = this.props.placeholder || 'Enter your text here...';
    }

    let class_name = "fake-textarea";
    if (this.props.className) {
      class_name += " " + this.props.className;
    }

    let styles = {};
    if (this.props.styles) {
      styles = this.props.styles;
    }

    return (
      <div id={this.props.id} className={class_name} readOnly={this.props.read_only} onClick={this.focus} style={this.props.style}>
        <Editor
          placeholder={placeholder_text}
          className="fake-textarea"
          editorState={this.state.editor_state}
          onChange={this.handleChange}
          readOnly={this.props.read_only}
          stripPastedStyles={true}
          ref={this.setEditorRef}
        />
      </div>
    );

  }

}

/**
 * This works quite well except if it is within a scrollable window and the textarea
 * overflows the scrolling element. In this case it causes the scroll to jump around
 * when text is first entered.
 */
export class ResizableTextarea extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = { rows: 1 };
  }

  componentDidMount = () => {
    this.setState({ rows: this.getCurrentRows(ReactDOM.findDOMNode(this)) });
  }

  getCurrentRows = (target) => {

    const min_rows = 1;
    const max_rows = 100;

    const textarea_lineheight = this.props.line_height;

    const previous_rows = target.rows;

    // Reset the number of rows in the textarea. We need to do this, so that
    // scrollHeight is at the minimum it can be for amount of text in the box.
    // Otherwise, as we delete text the number of rows becomes higher than
    // what is needed for the text box to show all the text, but this still
    // gets included in the scrollHeight calculation. In the other direction,
    // as more content is added which overflows the height of the textarea
    // the scrollHeight gets updated. Unfortunately, this causes a redraw
    // that messes with the parent scroll position.
    target.rows = min_rows;

    const current_rows = ~~(target.scrollHeight / textarea_lineheight);

    if (current_rows === previous_rows) {
      target.rows = current_rows;
    }

    if (current_rows >= max_rows) {
      target.rows = max_rows;
      target.scrollTop = target.scrollHeight;
    }

    return current_rows < max_rows ? current_rows : max_rows;
  }

  handleChange = (event) => {
    this.props.onChange(event.target.value);
    let new_rows = this.getCurrentRows(event.target);
    if (this.state.rows != new_rows) {
      this.setState({ rows: new_rows});
    }
  }

  render() {

    let style = Object.assign({}, this.props.style);
    style.lineHeight = this.props.line_height + 'px';
    style.resize = 'none'; // Allowing resize manually would allow the size of the box to get out of sync with what is calculated.

    let placeholder_text = null;
    if (!this.props.readOnly) {
      placeholder_text = this.props.placeholder || 'Enter your text here...';
    }

    return (
      <textarea
        id={this.props.id || null}
        name={this.props.name || null}
        style={style}
        rows={this.state.rows}
        value={this.props.value}
        readOnly={this.props.readOnly || false}
        placeholder={placeholder_text}
        className={this.props.className || null}
        onChange={this.handleChange}
      />
    );

  }

}
